/**
 * เบอร์ซิม — BUG-S2152-001
 *
 * ผู้ใช้คัดลอกเบอร์มาแบบ "080-000-0991" / "080 000 0991" / "+66 80 000 0991" บ่อย
 * ฟอร์มเคยปฏิเสธ (ต้องพิมพ์ใหม่) ขณะที่ API สร้างเดี่ยวรับไว้ทั้งขีด → เบอร์เดียวกันกลายเป็น 2 ซิม
 * ตัดตัวคั่นให้เป็นรูปเดียวกับ backend (`lenient_thai_phone`) ก่อนตรวจ 10 หลัก
 * รูปที่ไม่ใช่เบอร์ไทยคงไว้ตามเดิม ให้ด่าน 10 หลักเป็นคนบอกผู้ใช้
 */
export function normalizeSimPhone(raw: string): string {
  const s = (raw || '').trim();
  let cleaned = s.replace(/[\s\-().]/g, '');
  if (cleaned.startsWith('+66')) cleaned = '0' + cleaned.slice(3);
  else if (cleaned.startsWith('0066')) cleaned = '0' + cleaned.slice(4);
  return /^0\d{8,9}$/.test(cleaned) ? cleaned : s;
}

/** แยกหลายเบอร์จาก textarea (คั่น , หรือขึ้นบรรทัด) → ทำให้เป็นรูปเดียว + ตัดว่าง + ตัดซ้ำ (คงลำดับ) */
export function parsePhoneNumbers(raw: string): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const part of (raw || '').split(/[\n,]+/)) {
    const s = normalizeSimPhone(part);
    if (s && !seen.has(s)) {
      seen.add(s);
      out.push(s);
    }
  }
  return out;
}
